import { ReactElement } from 'react';
import { Box, useTheme } from '@mui/material';
import { isMobile } from 'react-device-detect';
import AnimatedVideoBackground from 'components/AnimatedVideoBackground';

type FormComponentType = {
  children: React.ReactNode;
};

const FormContainer = ({ children }: FormComponentType): ReactElement => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplate: {
          xs: `'form'`,
          md: `'form gif'`,
        },
        gridTemplateColumns: {
          xs: '100%',
          md: 'minmax(500px, 0.2fr) auto',
        },
        height: '100vh',
      }}
    >
      <Box
        gridArea="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          height: '100vh',
          [theme.breakpoints.down('sm')]: {
            maxWidth: '400px',
          },
          [theme.breakpoints.up('sm')]: {
            justifyContent: 'center',
          },
          paddingX: 'clamp(20px, 3vw, 56px)',
        }}
      >
        {children}
      </Box>

      {!isMobile && <AnimatedVideoBackground />}
    </Box>
  );
};

export default FormContainer;
